
<template>
  <div>
    <dialog-loading loadingText="Salvando" v-if="saving"></dialog-loading>
    <card-loading-transparent v-if="loading"></card-loading-transparent>

    <v-card outlined class="ma-3" v-if="!loading">
      <v-card-title class="content-border-title pl-4 pa-1">
        Informações
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-form ref="create_company_form" :disabled="!is_editable" class="mt-3">
          <template>
            <div v-if="reserve">
              <v-text-field dense class="mx-5" label="Reserva" outlined :readonly="!is_editable" v-model="company_financial.savings_goal" v-currency='currency' prefix="R$" :rules="not_zero"></v-text-field>
            </div>

            <div v-if="goal">
              <v-text-field dense class="mx-5" label="Meta" outlined :readonly="!is_editable" v-model="company_financial.base_monthly_goal" v-currency='currency' prefix="R$" :rules="not_zero"></v-text-field>
            </div>
          </template>
        </v-form>
      </v-card-text>
      <v-card-actions class="mx-auto justify-center"  style="max-width: 60vw;" v-if="!loading">
        <v-btn color="black" text small dense class="title-financial btn-primary" v-if="is_editable == false" @click="is_editable = !is_editable"><v-icon left>mdi-pencil</v-icon>Editar</v-btn>
        <v-btn color="black" text small dense class="title-financial btn-error" v-if="is_editable" @click="getCompanyFinancial()">Cancelar</v-btn>
        <v-btn color="black" text small dense class="title-financial btn-success" v-if="is_editable" @click="updateFinancial()">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import validations from "@/mixins/validations";
import { mapActions, mapState, mapGetters } from 'vuex'
import {CurrencyDirective} from 'vue-currency-input';
import Api from '@/api'

export default {
  name: 'CompanyFinancialSettings',
  props: {
    company_financial_infos: {
      type: Object,
      default: ()=> {}
    },
    reserve: {
      type: Boolean,
      default: false
    },
    goal: {
      type: Boolean,
      default: false
    }
  },
  directives: {
    currency: CurrencyDirective,
  },
  mixins: [ validations ],
  data() {
    return {
      currency:{
        currency: null,
        locale: 'en-EN',
        autoDecimalMode: true,
        decimalLength: 2,
        distractionFree:false,
      },
      is_editable: false,
      key: null,

      company: {},
      company_financial: {},
      loading: false,
      saving: false,
    }
  },
  methods: {
    getInfos(){
      this.getCompany()
      this.getCompanyFinancial()
    },
    getCompany() {
      if(this.activeCompanyId){
        this.loading = true
        Api.Company.show(this.activeCompanyId).then(r => r.data).then(company => {
          this.company = company
        }).catch((err) => {
          console.log({err});
          this.addNotification({type: 'error', msg: `${err.request.status} - Ocorreu um erro.`})
        }).finally(()=>{
          this.loading = false
        })
      }
    },
    getCompanyFinancial(){
      this.is_editable = false
      this.loading = true
      Api.CompanyFinancial.index({company_id: this.activeCompanyId}).then(r => r.data).then(company_financial => {
        this.company_financial = company_financial[0]
        this.setCompanyFinancialInfos()
      }).catch((err) => {
        this.addNotification({type: 'error', msg: `${err.request.status} - Ocorreu um erro.`})
      }).finally(()=>{
        this.loading = false
      })
    },

    setCompanyFinancialInfos(){
      this.company_financial = {
        ...this.company_financial,
        base_monthly_goal: (this.company_financial.base_monthly_goal / 100).toFixed(2),
        savings_goal: (this.company_financial.savings_goal / 100).toFixed(2),
      }
    },
    prepareCompanyFinancial(){
      return {
        ...this.company_financial,
        base_monthly_goal: Math.round(Number(this.company_financial.base_monthly_goal.replace(/,/g, '') )*100),
        savings_goal: Math.round(Number(this.company_financial.savings_goal.replace(/,/g, '') )*100),
      }
    },
    updateFinancial(){
      this.saving = true
      let noti = {
        type: 'success',
        msg: 'Feito com sucesso'
      }
      let comp_financial_aux = this.prepareCompanyFinancial()
      Api.CompanyFinancial.update(comp_financial_aux).then(r => r.data).then(company => {
        this.addNotification(noti)
      }).catch((err) => {
        noti = {
          type: 'error',
          msg: `Erro: ${err}`
        }
        console.log({err});
        this.addNotification(noti)
      }).finally(() => {
        this.saving = false
        this.is_editable = false
      })
    },
    ...mapActions({
      addNotification: 'Notification/add',
    })
  },
  mounted () {
    this.getInfos()
  },
  computed: {
    ...mapState({
        activeCompanyId: state => state.App.activeCompanyId
    }),
  },
  watch: {
    activeCompanyId(){
      this.getInfos()
    }
  },
}
</script>

<style scoped>

</style>